import { render, staticRenderFns } from "./RelatorioDetalhamentoRetroativo.vue?vue&type=template&id=a2daaabe"
import script from "./RelatorioDetalhamentoRetroativo.vue?vue&type=script&lang=js"
export * from "./RelatorioDetalhamentoRetroativo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDetalhamentoRetroativo.vue?vue&type=style&index=0&id=a2daaabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports